import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {GET_LIST, GET_ONE, CREATE, UPDATE, DELETE, DELETE_MANY, GET_MANY} from 'react-admin';
import {fileUploadBase64Payload} from '../common/Utils';
import {HTTP_GET, HTTP_POST, HTTP_DELETE} from '../common/HttpService';

const resourceBaseUlr = apiUrl + '/service';

export const getService = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getManyServices = async (params) => {
  const query = {
    filter: JSON.stringify({id: params.ids})
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getServices = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;

  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(params.filter)
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const createService = async (params) => {
  const url = `${resourceBaseUlr}`;
  let ImgUrl = '';
  if (params.data.images && params.data.images.title) {
    const imageUploadParams = {};
    const imagesss = await fileUploadBase64Payload([params.data.images], 'image');
    imageUploadParams.data = {};
    imageUploadParams.data.payloads = imagesss;
    imageUploadParams.data.resource = 'service';
    imageUploadParams.data.resourceName = params.data.serviceName ? params.data.serviceName : '';
    imageUploadParams.data.id = 1;
    const url = apiUrl + '/upload';
    const body = imageUploadParams.data;
    let res = await HTTP_POST(url, body);
    if (res.success && res.data.length == 1) {
      ImgUrl = res.data[0];
    }
  }
  params.data.imagePath = ImgUrl;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const updateService = async (params) => {
  const {id} = params;
  let ImgUrl = '';
  if (params.data.images && params.data.images.title) {
    const imageUploadParams = {};
    const imagesss = await fileUploadBase64Payload([params.data.images], 'image');
    imageUploadParams.data = {};
    imageUploadParams.data.payloads = imagesss;
    imageUploadParams.data.resource = 'service';
    imageUploadParams.data.resourceName = params.data.serviceName ? params.data.serviceName : '';
    imageUploadParams.data.id = 1;
    const url = apiUrl + '/upload';
    const body = imageUploadParams.data;
    let res = await HTTP_POST(url, body);
    if (res.success && res.data.length == 1) {
      ImgUrl = res.data[0];
    }
  }
  const url = `${resourceBaseUlr}/${id}`;
  params.data.imagePath = ImgUrl;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteService = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_DELETE(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteMany = async (params) => {
  const url = `${resourceBaseUlr}`;
  const body = params;
  let res = await HTTP_DELETE(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const ServiceDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getServices(params);

    case GET_MANY:
      return getManyServices(params);

    case GET_ONE:
      return getService(params);

    case CREATE:
      return createService(params);

    case UPDATE:
      return updateService(params);

    case DELETE:
      return deleteService(params);

    case DELETE_MANY:
      return deleteMany(params);

    default:
      return Promise.reject('Unknown Type');
  }
};

export default ServiceDataProvider;
